module.exports = __webpack_public_path__ + "img/step3.55e00e3.png";